import { useMemo } from 'react';

import { Trans } from '@lingui/react/macro';
import { useAtomValue } from 'jotai';

import { selectedPlanAtom } from '../../../atoms';

import { TreatmentHistoryTable } from './TreatmentHistoryTable';

export const TreatmentHistorySection = () => {
  // atoms
  const currentPlan = useAtomValue(selectedPlanAtom);

  // Transform Zuub treatment history data
  const treatmentHistoryData = useMemo(() => {
    if (!currentPlan?.treatmentHistory) {
      return { treatmentHistory: [], isValid: false };
    }

    return {
      treatmentHistory: currentPlan.treatmentHistory || [],
      isValid: true,
    };
  }, [currentPlan]);

  // Only show data if we have valid treatment history data
  if (!treatmentHistoryData.isValid) {
    return (
      <div className="vai-text-center vai-text-gray-500 vai-py-8">
        <Trans>
          No treatment history data available for the selected plan.
        </Trans>
      </div>
    );
  }

  return <TreatmentHistoryTable data={treatmentHistoryData.treatmentHistory} />;
};
